<template>
  <div v-loading="contentLoading">
    <div class="title">基本信息</div>
    <table cellspacing="0" cellpadding="0" class="ClienContractPreview" style="width: 100%">
      <div v-if="!isBorrow">
        <tr>
          <td class="tableLabel">合同类型</td>
          <td class="tableContent">{{clientContract.clientContractTypeDesc}}</td>
          <td class="tableLabel">紧急程度</td>
          <td class="tableContent">{{clientContract.urgent}}</td>
          <td class="tableLabel">销售员</td>
          <td class="tableContent">{{clientContract.salesPersonName}}</td>
          <td class="tableLabel">销售员部门</td>
          <td class="tableContent">{{clientContract.salesPersonDepartment}}</td>
        </tr>
        <tr>
          <td class="tableLabel">抄送人员</td>
          <td class="tableContent">{{clientContract.sendPeopleName}}</td>
          <td class="tableLabel">申请日期</td>
          <td class="tableContent">{{clientContract.createTime}}</td>
          <td class="tableLabel">盖章份数</td>
          <td class="tableContent">{{clientContract.stampQty}}</td>
          <td class="tableLabel"/>
          <td class="tableContent"/>
        </tr>
      </div>
      <div v-if="isBorrow">
        <tr>
          <td class="tableLabel">合同类型</td>
          <td class="tableContent">{{clientContract.clientContractTypeDesc}}</td>
          <td class="tableLabel">续借</td>
          <td class="tableContent">
            <spanv v-if="clientContract.nextBorrow===true">是</spanv>
            <spanv v-if="clientContract.nextBorrow===false">否</spanv>
          </td>
          <td class="tableLabel">所属PDT</td>
          <td class="tableContent">
            <span v-if="clientContract.belongToPDTCode===3">BU14泛电子智能产线</span>
            <span v-if="clientContract.belongToPDTCode===4">工业机器人产品线</span>
            <span v-if="clientContract.belongToPDTCode===5">桌面型机器人产品线</span>
            <span v-if="clientContract.belongToPDTCode===0">代理业务</span>
            <span v-if="clientContract.belongToPDTCode===1">国产运控产品线</span>
            <span v-if="clientContract.belongToPDTCode===2">BU10控制及集成</span>
          </td>
          <td class="tableLabel">借用产品分类</td>
          <td class="tableContent">
            <span v-if="clientContract.productTypeCode===18">视觉产品</span>
            <span v-if="clientContract.productTypeCode===22">系统</span>
            <span v-if="clientContract.productTypeCode===19">伺服电机</span>
            <span v-if="clientContract.productTypeCode===20">控制卡</span>
            <span v-if="clientContract.productTypeCode===21">PAC控制器</span>
            <span v-if="clientContract.productTypeCode===12">BU14泛电子智能产线</span>
            <span v-if="clientContract.productTypeCode===13">工业机器人</span>
            <span v-if="clientContract.productTypeCode===14">桌面型机器人</span>
            <span v-if="clientContract.productTypeCode===15">编码器</span>
            <span v-if="clientContract.productTypeCode===0">代理产品</span>
            <span v-if="clientContract.productTypeCode===11">系统与方案</span>
            <span v-if="clientContract.productTypeCode===1">辛格林纳Ω6</span>
            <span v-if="clientContract.productTypeCode===2">辛格林纳EM/MS</span>
            <span v-if="clientContract.productTypeCode===3">众为兴旋转/AP2/AN2</span>
            <span v-if="clientContract.productTypeCode===4">佰匠IK3/AN1</span>
            <span v-if="clientContract.productTypeCode===5">之山-通用</span>
            <span v-if="clientContract.productTypeCode===6">之山-专机</span>
            <span v-if="clientContract.productTypeCode===7">之山IK3/AN1</span>
            <span v-if="clientContract.productTypeCode===8">之山其他产品</span>
            <span v-if="clientContract.productTypeCode===9">众为兴直线伺服</span>
            <span v-if="clientContract.productTypeCode===10">控制及集成</span>
            <span v-if="clientContract.productTypeCode===16">SC20/SC30/SC50/控制卡</span>
            <span v-if="clientContract.productTypeCode===17">CNC/点胶/植毛/弹簧/模板机</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">试用品借用公司</td>
          <td class="tableContent">
            <span v-if="clientContract.borrowCompanyCode===4">机器人公司</span>
            <span v-if="clientContract.borrowCompanyCode===0">会通公司</span>
            <span v-if="clientContract.borrowCompanyCode===1">佰匠公司</span>
            <span v-if="clientContract.borrowCompanyCode===2">之山公司</span>
            <span v-if="clientContract.borrowCompanyCode===3">众为兴公司</span>
          </td>
          <td class="tableLabel">会签人</td>
          <td class="tableContent">{{clientContract.countersignName}}</td>
          <td class="tableLabel">抄送人员</td>
          <td class="tableContent">{{clientContract.sendPeopleName}}</td>
          <td class="tableLabel">试用原因</td>
          <td class="tableContent">{{clientContract.clientContractAbstract}}</td>
        </tr>
      </div>
    </table>
    <div class="title">合同内容信息</div>
    <table cellspacing="0" cellpadding="0" class="ClienContractPreview" style="width: 100%">
      <div v-if="clientContract.clientContractType===10">
        <tr>
          <td class="tableLabel">协议编号</td>
          <td class="tableContent">{{clientContract.clientContractNo}}</td>
          <td class="tableLabel">协议所属公司</td>
          <td class="tableContent">{{clientContract.belongToCustomerNo}}</td>
          <td class="tableLabel">税号</td>
          <td class="tableContent">{{clientContract.unifiedSocialCreditCode}}</td>
          <td class="tableLabel">渠道商名称</td>
          <td class="tableContent">{{clientContract.customerName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">渠道商类型</td>
          <td class="tableContent">{{clientContract.customerType}}</td>
          <td class="tableLabel">渠道商等级</td>
          <td class="tableContent">{{clientContract.dealerLevel}}</td>
          <td class="tableLabel">协议金额</td>
          <td class="tableContent">{{clientContract.clientContractAmount}}</td>
          <td class="tableLabel">协议金额(大写)</td>
          <td class="tableContent">{{clientContract.clientContractAmountChinese}}</td>
        </tr>
        <tr>
          <td class="tableLabel">信贷额度</td>
          <td class="tableContent">{{clientContract.creditLimit}}</td>
          <td class="tableLabel">区域范围</td>
          <td class="tableContent">{{clientContract.province}}</td>
          <td class="tableLabel">销售对象产品</td>
          <td class="tableContent">{{clientContract.salesTargetProduct}}</td>
          <td class="tableLabel">特定行业</td>
          <td class="tableContent">{{clientContract.specificIndustries}}</td>
        </tr>
        <tr>
          <td class="tableLabel">最少专职销售人员</td>
          <td class="tableContent">{{clientContract.customerSalesPeople}}</td>
          <td class="tableLabel">最少专职技术工程师</td>
          <td class="tableContent">{{clientContract.customerEngineer}}</td>
          <td class="tableLabel">渠道商担保人</td>
          <td class="tableContent">{{clientContract.customerGuarantor}}</td>
          <td class="tableLabel">担保人身份证号码</td>
          <td class="tableContent">{{clientContract.guarantorIdNumber}}</td>
        </tr>
        <tr>
          <td class="tableLabel">担保人家庭住址</td>
          <td class="tableContent">{{clientContract.guarantorIdNumber}}</td>
          <td class="tableLabel">担保人电话</td>
          <td class="tableContent">{{clientContract.customerSalesPeople}}</td>
          <td class="tableLabel">最少专职技术工程师</td>
          <td class="tableContent">{{clientContract.customerEngineer}}</td>
          <td class="tableLabel"/>
          <td class="tableContent"/>
        </tr>
      </div>
      <div v-if="clientContract.clientContractType===20">
        <tr>
          <td class="tableLabel">合同编号</td>
          <td class="tableContent">{{clientContract.clientContractNo}}</td>
          <td class="tableLabel">合同所属公司</td>
          <td class="tableContent">{{clientContract.belongToCustomerNo}}</td>
          <td class="tableLabel">客户名称</td>
          <td class="tableContent">{{clientContract.customerName}}</td>
          <td class="tableLabel">公司统一模板</td>
          <td class="tableContent">{{clientContract.commonModel}}</td>
        </tr>
        <tr>
          <td class="tableLabel">框架合同</td>
          <td class="tableContent">{{clientContract.framework}}</td>
          <td class="tableLabel">合同金额</td>
          <td class="tableContent">{{clientContract.clientContractAmount}}</td>
          <td class="tableLabel">合同金额(大写)</td>
          <td class="tableContent">{{clientContract.clientContractAmountChinese}}</td>
          <td class="tableLabel"/>
          <td class="tableContent"/>
        </tr>
        <tr>
          <td class="tableLabel">合同内容摘要</td>
          <td class="tableContent" colspan="7">{{clientContract.clientContractAbstract}}</td>
        </tr>
      </div>
      <div v-if="isCommon">
        <tr>
          <td class="tableLabel">合同编号</td>
          <td class="tableContent">{{clientContract.clientContractNo}}</td>
          <td class="tableLabel">客户合同编号</td>
          <td class="tableContent">{{clientContract.customerClientContractNo}}</td>
          <td class="tableLabel">客户名称/渠道商名称</td>
          <td class="tableContent">{{clientContract.customerName}}</td>
          <td class="tableLabel">付款方式</td>
          <td class="tableContent">{{clientContract.paymentDays}}</td>
        </tr>
        <tr>
          <td class="tableLabel">OEM/终端名称</td>
          <td class="tableContent">{{clientContract.finalCustomerName}}</td>
          <td class="tableLabel"/>
          <td class="tableContent"/>
          <td class="tableLabel"/>
          <td class="tableContent"/>
          <td class="tableLabel"/>
          <td class="tableContent"/>
        </tr>
        <div v-if="clientContract.clientContractType===50 || clientContract.clientContractType=== 60">
          <tr>
            <td class="tableLabel">试用时间</td>
            <td class="tableContent">
              <span v-if="clientContract.borrowTimeCode===0">30天内</span>
              <span v-if="clientContract.borrowTimeCode===1">31-60天</span>
              <span v-if="clientContract.borrowTimeCode===2">61-90天</span>
              <span v-if="clientContract.borrowTimeCode===3">90天以上</span>
            </td>
            <td class="tableLabel">截止时间</td>
            <td class="tableContent">{{clientContract.expirationDate}}</td>
            <td class="tableLabel"/>
            <td class="tableContent"/>
            <td class="tableLabel"/>
            <td class="tableContent"/>
          </tr>
          <tr>
            <td class="tableLabel">收货信息</td>
            <td class="tableContent" colspan="7">{{clientContract.deliveryMessage}}</td>
          </tr>
        </div>
      </div>
    </table>
    <div v-if="isCommon || isBorrow" class="title">合同明细</div>
    <el-table v-if="isCommon || isBorrow" ref="elTable" :data="clientContract.materialList" border>
      <el-table-column
          prop="materialNo"
          align="center"
          label="物料编号"
          width="150"/>
      <el-table-column
          prop="materialName"
          align="center"
          label="物料描述"
          show-overflow-tooltip
          width="360"/>
      <el-table-column
          v-if="clientContract.clientContractType===40"
          prop="refBillNo"
          align="center"
          label="销售单号"
          width="150"/>
      <el-table-column
          v-if="clientContract.clientContractType===40"
          prop="refRowIndex"
          align="center"
          label="销单行项"
          width="100"/>
      <el-table-column
          prop="specification"
          align="center"
          label="规格型号"
          show-overflow-tooltip
          width="360"/>
      <el-table-column
          prop="quantity"
          align="center"
          label="数量"
          width="100"/>
      <el-table-column
          prop="unitPrice"
          align="center"
          label="单价"
          width="100"/>
      <el-table-column
          prop="totalPrice"
          align="center"
          label="总价">
        <template slot-scope="scope">
          <span>{{scope.row.quantity * scope.row.unitPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column
          v-if="isBorrow"
          prop="deliveryDate"
          align="center"
          label="期望交期"
          width="200"/>
      <el-table-column
          v-if="isBorrow"
          prop="oldOrNew"
          align="center"
          label="新/旧机"
          width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.oldOrNew===0">新机</span>
          <span v-if="scope.row.oldOrNew===1">旧机</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>

  export default {
    name: "ClienContractPreview",
    components: {},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        isCommon: true,
        isBorrow: false,
        authIndex: this.$route.meta.authIndex,
        limits: {
          editAuth: this.$auth(235),
          downloadAuth: this.$auth(235),
          delAuth: this.$auth(235),
          uploadAuth: this.$auth(235),
        },
        payMethods: [],
        clientContract: {
          pkId: 0,
          clientContractType: 30,
          clientContractName: "",
          urgent: "正常",
          salesPersonName: "",
          salesPersonId: "",
          salesPersonDepartment: "",
          sendPeopleId: "",
          createTime: "",
          stampQty: "",
          clientContractNo: "",
          customerClientContractNo: "",
          belongToCustomerNo: "新时达工控技术（杭州）有限公司",
          customerId: "",
          customerNo: "",
          customerName: "",
          finalCustomerNo: "",
          finalCustomerName: "",
          deliveryMessage: "",
          clientContractAmount: "",
          clientContractAmountChinese: "",
          settlementMethod: "",
          creditLimit: "",
          clientContractAbstract: "",
          customerType: "",
          dealerLevel: "",
          commonModel: "",
          framework: "",
          clientContractDeliveryDate: "",
          sourceId: "",
          sourceClientContractNo: "",
          oaProcessNumber: "",
          sendPeopleName: "",
          accessoryList: [],
          materialList: [],
          unifiedSocialCreditCode: "",
          province: "",
          salesTargetProduct: "",
          specificIndustries: "",
          customerSalesPeople: 0,
          customerEngineer: 0,
          customerGuarantor: "",
          guarantorIdNumber: "",
          guarantorAddress: "",
          guarantorPhone: "",
          nextBorrow: 0,
          belongToPDTCode: "",
          belongToPDTName: "",
          productTypeCode: "",
          productTypeName: "",
          borrowCompanyCode: "",
          borrowCompanyName: "",
          countersignNumber: "",
          countersignName: "",
          customerAddress: "",
          borrowTimeCode: "",
          borrowTimeName: "",
          processorId: "",
          processorName: "",
          processorOA: "",
          expirationDate: "",
        },
        materialFilter: {
          status: 10,//启用
          priceStatus: 30,//已通过
        },
        ruleValidate: {
          salesPersonName: {required: true, message: "请选择销售员", trigger: "blur"},
          customerName: {required: true, message: "请选择渠道商/客户", trigger: "blur"},
          urgent: {required: true, message: "请选择紧急程度", trigger: "blur"},
        },
      };
    },
    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "ClienContractPreview") {
            this.getData(this.$route.query.billId);
          }
        },
      },
    },
    created() {
      this.clientContract.pkId = this.$route.query.billId;
      this.getData(this.$route.query.billId);
    },
    methods: {
      setIsCommon() {
        if (this.clientContract.clientContractType === 30 || this.clientContract.clientContractType === 40) {
          this.isCommon = true;
        } else if (this.clientContract.clientContractType === 50 || this.clientContract.clientContractType === 60) {
          this.isBorrow = true;
        } else {
          this.isCommon = false;
          this.isBorrow = false;
        }
      },


      // 获取详情
      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `clientContracts/${pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.clientContract = Object.assign(this.clientContract, resp.data);
              this.setIsCommon();
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
.ClienContractPreview {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.ClienContractPreview td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}

.tableContent {
  width: 240px;
  text-align: left;
  white-space: pre-wrap;
}
</style>
